module.exports = __webpack_public_path__ + "static/media/userImg.d816de83.PNG";